import styles from "./styles.module.scss"
import cruisenLogoTransparent from "../../../assets/cruisenLogoTransparent.png"
import CheckmarkIcon from "~icons/eva/checkmark-circle-2-outline"

const features = [
  "Seamless advisor communication",
  "Full cruise availability with filtering",
  "Weekly price drop monitoring",
  "Everything in one place",
]

export const DownloadMobileAppModal = ({
  closeModal,
  tripInviteLink,
}: {
  closeModal: () => void
  tripInviteLink: string
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <img src={cruisenLogoTransparent} alt="Cruisen logo" className={styles.headingLogo} />
      </div>
      <div className={styles.content}>
        <p className={styles.contentTitle}>Do more with the Cruisen app</p>
        <div>
          <p className={styles.contentDescription}>Download our app to get access to:</p>
          <div className={styles.featuresContainer}>
            {features.map((feature) => (
              <div key={feature} className={styles.feature}>
                <CheckmarkIcon className={styles.featureIcon} />
                <p className={styles.featureText}>{feature}</p>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <button
            className={styles.downloadButton}
            onClick={() => {
              window.open(tripInviteLink, "_blank")
              closeModal()
            }}
          >
            Download app
          </button>
          <button className={styles.laterButton} onClick={closeModal}>
            Later
          </button>
        </div>
      </div>
    </div>
  )
}
